import {
  doUpdateUserPreferences,
  selectShowKbSearchOnInboxEditor,
} from 'ducks/currentUser'

export function doToggleShowKbSearchOnInboxEditor() {
  return (dispatch, getState) => {
    const state = getState()
    const showKbSearchOnInboxEditor = selectShowKbSearchOnInboxEditor(state)
    return doUpdateUserPreferences({
      show_kb_search_on_inbox_editor: !showKbSearchOnInboxEditor,
    })(dispatch, getState)
  }
}
